export default "__VITE_ASSET__xY8ecsxZ__"